module.exports = __webpack_public_path__ + "img/PPMP31.526a7956.png";